import {currentCulture} from "@2d-front-monorepo/core";

export function formatPercentage(value?: number | null | undefined): string {
	if (value == null) {
		return "";
	}

	return currentCulture().formatNumber(value / 100, "percent");
}
